export default __webpack_public_path__ + "static/media/deliverit-extra.e4aa87ed.gif";